var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTiendas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7999 13.05H7.09994C5.76893 13.05 4.68994 14.129 4.68994 15.46V23.29C4.68994 24.6211 5.76893 25.7 7.09994 25.7H23.7999C25.1309 25.7 26.2099 24.6211 26.2099 23.29V15.46C26.2099 14.129 25.1309 13.05 23.7999 13.05Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7298 8.39C25.2698 7.53 24.3798 7 23.3998 7H7.59983C6.60983 7 5.69983 7.56 5.24983 8.44L3.32983 12.2C2.34983 14.12 3.64983 16.46 5.79983 16.56C5.84983 16.56 5.89983 16.56 5.94983 16.56C7.71983 16.56 9.15983 15.12 9.15983 13.35C9.15983 15.12 10.5998 16.56 12.3698 16.56C14.1398 16.56 15.5798 15.12 15.5798 13.35C15.5798 15.12 17.0198 16.56 18.7898 16.56C20.5598 16.56 21.9998 15.12 21.9998 13.35C21.9998 15.12 23.4398 16.56 25.2098 16.56C25.2598 16.56 25.3098 16.56 25.3598 16.56C27.5198 16.46 28.8098 14.08 27.7898 12.17L25.7598 8.39H25.7298Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1298 18.5801H13.2498C14.1098 18.5801 14.8098 19.2801 14.8098 20.1401V25.7001H9.56982V20.1401C9.56982 19.2801 10.2698 18.5801 11.1298 18.5801Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTiendas);
export default __webpack_public_path__ + "static/media/Ico_Tiendas.e5bf8a48ac2a7548725c9489f1e36366.svg";
export { ForwardRef as ReactComponent };